import React from 'react';
import PropTypes from 'prop-types';
import MuiGrid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MuiButton from '@material-ui/core/Button';
import Wrap from '../../depi/sections/Wrap';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import ResultCard from '../../Filter/Card';
import { makeStyles } from '@material-ui/core/styles';
import useStores from '../../../utils/useStores';
import useCols from '../../../utils/useCols';

const useStyles = makeStyles(() => ({
  list: {
    overflow: 'visible',
  },
  tile: {
    overflow: 'visible',
  },
}));

const CardsSection = props => {
  const { noTitle, noButton, label, centeredLabel, data, href } = props;
  const { uiStore } = useStores();
  const classes = useStyles();
  const cols = useCols();
  return (
    <Wrap bgcolor="grey.100">
      {!noTitle && (
        <Box mb={4} textAlign={centeredLabel ? 'center' : 'inherit'}>
          <Typography variant="h3">{label}</Typography>
        </Box>
      )}
      {data && (
        <Box mb={8}>
          <GridList
            className={classes.list}
            cellHeight="auto"
            cols={cols}
            spacing={16}
          >
            {data.map(d => (
              <GridListTile
                classes={{ tile: classes.tile }}
                key={d.uuid}
                col={1}
              >
                <ResultCard data={d} context={uiStore.context} />
              </GridListTile>
            ))}
          </GridList>
        </Box>
      )}
      {!noButton && (
        <Box textAlign="center">
          <MuiButton
            href={href}
            target="_blank"
            size="large"
            variant="outlined"
          >{`Mehr ${label}`}</MuiButton>
        </Box>
      )}
    </Wrap>
  );
};

CardsSection.defaultProps = {
  label: null,
  button: null,
  centeredLabel: false,
  noButton: false,
  noTitle: false,
};

CardsSection.propTypes = {
  data: PropTypes.array.isRequired,
  href: PropTypes.string.isRequired,
  label: PropTypes.string,
  centeredLabel: PropTypes.bool,
  noTitle: PropTypes.bool,
  noButton: PropTypes.bool,
};

export default CardsSection;
